<template>
    <site-layout>
        <base-message v-if="!free_signup && !is_invitation">
            <strong>Sign up form is disabled in this project.</strong>
        </base-message>

        <base-message v-else-if="success">
            <b>Please verify your email.</b>
            Cheers! Account has been successfully created.
            We just sent you email with confirmation link.<br/><br/>

            <a v-if="!success_resent" @click="resend_email">Resend verification email.</a>
            <span v-if="resend.loading" class="loader"></span>
        </base-message>

        <div v-else-if="is_invitation && invitation_detail.loading" class="loader title"></div>

        <template v-else>
            <div align="center">
                <img src="../assets/img/logo.png" class="site-logo container" alt=""/>
                <div class="has-text-white"><b>Sign up</b></div><br/>
            </div>

            <base-backend-errors :data="signup.error"/>

            <base-input
                v-model="form.email"
                name="email"
                icon="fas fa-envelope"
                validate="required|email"
                placeholder="Email"
                :disabled="is_invitation"/>

            <div class="field">
                <div class="field-body">
                    <base-input
                        v-model="form.first_name"
                        name="first_name"
                        icon="fas fa-user"
                        validate="required"
                        placeholder="First name"/>

                    <base-input
                        v-model="form.last_name"
                        name="last_name"
                        icon="fas fa-user"
                        validate="required"
                        placeholder="Last name"/>
                </div>
            </div>

            <base-input v-model="form.password" name="password" icon="fas fa-lock"
                        validate="required" placeholder="Password" type="password"/>

            <base-button
                @click="submit"
                :loading="signup.loading"
                class="is-success is-fullwidth"
                icon="fas fa-check"
                text="Sign up"/>
        </template>

        <base-button
            :to="{name: 'signin'}"
            class="is-primary is-fullwidth"
            icon="fas fa-sign-in-alt"
            text="Sign in"/>
    </site-layout>
</template>

<script>
import { mapState } from 'vuex';
import SiteLayout from '../components/layouts/SiteLayout.vue';

export default {
    name: 'Signup',
    components: { SiteLayout },
    data() {
        return {
            success: false,
            success_resent: false,
            form: {
                email: null, first_name: null, last_name: null, company: null, password: null,
            },
        };
    },
    computed: {
        ...mapState('configurations', ['free_signup']),
        ...mapState('signup', ['signup', 'resend']),
        ...mapState('invitation', { invitation_detail: 'detail' }),
        is_invitation() {
            return !!this.$route.params.invitation_key;
        },
    },
    created() {
        if (this.is_invitation) {
            this.$store.dispatch('invitation/detail', {
                key: this.$route.params.invitation_key,
            }).then((data) => {
                this.form.invitation = this.$route.params.invitation_key;
                this.form.email = data.email;
            });
        }
    },
    methods: {
        submit() {
            this.$validator.validate().then((result) => {
                if (!result) return null;
                return this.$store.dispatch('signup/signup', this.form).then(this.on_success);
            });
        },
        on_success() {
            if (this.is_invitation) {
                // If user is signing up with invitation code,
                // he can sign in without email confirmation.
                this.$store.dispatch('signin/signin', this.form).then(() => {
                    this.$router.push({ name: 'spaces' });
                });

                return;
            }

            this.success = true;
        },
        resend_email() {
            this.$store.dispatch('signup/resend', this.signup.data.id).then(() => {
                this.success_resent = true;
            });
        },
    },
};
</script>
